import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { serviceURLService } from '../service/serviceURL';
import { CommonService } from '../services/common.service';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead/typeahead-match.class';

import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';

@Component({
    selector: 'app-partner-lead',
    templateUrl: './partner-lead.component.html',
    styleUrls: ['./partner-lead.component.css'],
    providers: [CommonService]
})
export class PartnerLeadComponent implements OnInit {
    loading: boolean;
    cityList: any = [];
    noResult = false;
    lead: any = {};
    roleData: any = {};
    private onDestroy$: Subject<void> = new Subject<void>();

    //for disabling div  in production
    constructor(private router: Router, private _location: Location, private serviceURLService: serviceURLService, public commonService: CommonService) {

    }

    ngOnInit() {
        this.getCities();
        this.roleData = JSON.parse(localStorage.getItem('role'));
    }

    getCities() {
        this.loading = true;
        this.serviceURLService.getCities().pipe(takeUntil(this.onDestroy$)).subscribe(
            (success: any) => {
                this.loading = false;
                this.cityList = success.data.cityList;
            }, error => {
                this.loading = false;
            }
        );
    }

    selectCity(event: TypeaheadMatch): void {
        this.noResult = this.commonService.onSelectCity(event);
    }

    checkCityValue(event): void {
        this.noResult = this.commonService.checkCityValue(event, this.cityList);
    }

    createProspect() {
        this.lead.product = 23;
        this.lead.rmId = this.roleData.pamUserID;
        this.lead.leadSource= "Notify-App";
        this.lead.channel = "Notify-App"
        this.serviceURLService.createProspect(this.lead).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
            this.router.navigate(['motor-insurance']);
            localStorage.setItem('prospectIdMotor', successData.data.prospectId);
            this.assigntoRM(successData.data.prospectId);
        }, errorData => {

        }
        );
    }

    assigntoRM(prospectId) {
        const formData: FormData = new FormData();
        formData.append('rmId', this.roleData.pamUserID);
        formData.append('prospectId', prospectId);
        this.serviceURLService.assignToRM(formData).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
        }, errorData => {

        }
        );
    }

    ngOnDestroy(): void {
        this.onDestroy$.next();
        this.onDestroy$.complete();
      }


}